import React, { useEffect, useState } from 'react'
// import { IoMdWarning } from 'react-icons/io'

const PasswordSettings = (props) => {
    const { TransactionType } = props

    const [oldPass, setOldPass] = useState('')
    const [newPass, setNewPass] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [status, setStatus] = useState({ message: '', type: '' });
    const [showModal, setShowModal] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const [validationError, setValidationError] = useState({})

    const validateForm = () => {
        const passwordRegex = /^.{8,}$/;

        let error = {}

        if (!passwordRegex.test(newPass)) {
            error.password = 'Password must contain a minimum of 8 characters.'
        }

        setValidationError(error)
        return Object.keys(error).length === 0;
    }

    useEffect(() => {
        if (oldPass !== '' && newPass !== '') {
            setIsDirty(true)
        } else {
            setIsDirty(false)
        }
    }, [oldPass, newPass])

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            console.log("Validation failed!");
            return;
        }

        setIsSubmitting(true);

        try {
            const token = localStorage.getItem("token");
            if (!token) {
                setStatus({ message: "Not authenticated. Please log in again.", type: "error" });
                return;
            }

            const payload = {
                old_password: oldPass,
                new_password: newPass,
            };

            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/update_password`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    Authorization: `Token ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (!response.ok) {
                setShowModal(true);
                throw new Error(data.message || data.detail || "Update failed");
            }

            // success
            setStatus({ message: "Password updated successfully!", type: "success" });
            setShowModal(true);
            setOldPass("");
            setNewPass("");
            console.log("Update successful:", data);

        } catch (error) {
            console.error("Error during update:", error.error);
            setStatus({ message: 'Failed to update password. Try again later', type: "error" });
        } finally {
            setIsSubmitting(false);
            setIsDirty(false);
        }
    };

    if (showModal) {
        setTimeout(() => {
            setShowModal(false)
        }, 3000);
    }

    return (
        <div className={TransactionType === 'password' ? 'flex flex-col gap-10 lg:w-[90%]' : 'hidden'}>
            <div className='flex justify-between relative'>
                <div className='flex flex-col gap-1'>
                    <p className='text-[18px] font-medium text-[#1D1C1F]'>Password settings</p>
                    <p className='text-[14px] font-normal text-[#525154]'>Update your password</p>
                </div>
                <button
                    onClick={handleSubmit}
                    className={`text-[#531CB3] sa:block hidden text-[14px] font-medium px-4 py-[10px] rounded-lg ${isSubmitting || !isDirty ? 'bg-[#E8E1F5] cursor-not-allowed' : 'bg-[#531CB3] cursor-pointer text-white'}`}
                    disabled={isSubmitting || !isDirty}
                >
                    {isSubmitting ? (
                        'Loading...'
                    ) : (
                        'Save Changes'
                    )}
                </button>
                {showModal && (
                    <div className={status.type === 'error' ? 'bg-red-500 absolute top-3 left-1/2 -translate-x-1/2 text-white p-2 rounded-md flex items-center justify-between' : 'bg-green-500 absolute top-3 left-1/2 -translate-x-1/2 text-white p-2 rounded-md flex items-center justify-between'}>
                        <p className='text-[16px] font-bold'>
                            {status.message}
                        </p>
                        {/* {status.type === 'error' && <IoMdWarning className='text-[25px]' />} */}
                    </div>
                )}
            </div>
            <div className='flex sm:flex-row flex-col sm:items-center gap-5'>
                <div className='sm:w-[40%]'>
                    <p className='text-[14px] font-medium text-[#1D1C1F]'>Current password</p>
                </div>
                <input
                    type="text"
                    name="current"
                    value={oldPass}
                    onChange={(e) => setOldPass(e.target.value)}
                    id=""
                    required
                    className='rounded-lg py-[10px] sm:w-[70%] px-[14px] border border-[#D2D0D6]'
                    placeholder='Your current password'
                />
            </div>
            <div className='flex sm:flex-row flex-col sm:items-center gap-5'>
                <div className='sm:w-[40%]'>
                    <p className='text-[14px] font-medium text-[#1D1C1F]'>New password</p>
                </div>
                <input
                    type="text"
                    name="new"
                    value={newPass}
                    onChange={(e) => setNewPass(e.target.value)}
                    id=""
                    required
                    className='rounded-lg py-[10px] sm:w-[70%] px-[14px] border border-[#D2D0D6]'
                    placeholder='Your new password'
                />
                {validationError.password && <p className='text-red-500 text-[14px]'>{validationError.password}</p>}
            </div>
        </div>
    )
}

export default PasswordSettings